import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_API_URL || 'http://localhost:3000/api', // Uses the environment variable or falls back
    headers: {
        'X-API-KEY': process.env.VUE_APP_API_KEY,
    }
});

// export const getRecentChanges = async () => {
//     const response = await api.get(`/recent-changes`);
//     return response.data;
// };

export const getRecentPeople = async (limit = 30) => {
    // Limit stays client-controlled so overview pages can tune payload size.
    const response = await api.get(`/recent-people?limit=${limit}`);
    return response.data;
};

export const getRecentMedia = async (limit = 30) => {
    // Same contract as recent people endpoint for consistent list components.
    const response = await api.get(`/recent-media?limit=${limit}`);
    return response.data;
};

export const getRecentChanges = async (limit = 100) => {
    const parsedLimit = Number.parseInt(limit, 10);
    const safeLimit = Number.isFinite(parsedLimit) && parsedLimit > 0 ? parsedLimit : 100;
    const [people, media] = await Promise.all([
        getRecentPeople(safeLimit),
        getRecentMedia(safeLimit),
    ]);

    const normalizedPeople = people.map(person => ({
        ...person,
        key: `person-${person.personID || person.nodeID}`,
        kind: 'person',
    }));

    const normalizedMedia = media.map(item => {
        const kind = item.mediaType === 'documents' ? 'document' : 'photo';

        return {
            ...item,
            key: `${kind}-${item.mediaID}`,
            kind,
        };
    });

    return [...normalizedPeople, ...normalizedMedia]
        .sort((left, right) => {
            const dateOrder = String(right.changedate || '').localeCompare(String(left.changedate || ''));
            return dateOrder || left.key.localeCompare(right.key);
        })
        .slice(0, safeLimit);
};
